require('jquery');
require('popper.js');
require('bootstrap/dist/js/bootstrap');
require('./scss/main.scss');

$(function () {
    $('[data-toggle="tooltip"]').tooltip()
});
